import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-not-found-component',
    templateUrl: './not-found-component.component.html',
    styleUrls: ['./not-found-component.component.css'],
    standalone: false
})
export class NotFoundComponent implements OnInit {
  path: string;
  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.data.pipe(take(1))
    .subscribe(data => {
      this.path = data.path;
    });
  }
}
